import React from "react";
import Header from "./layout/Header";
import Footer from "./layout/Footer";
import PromiseStrip from "./layout/PromiseStrip";
import { useCtaTracker } from "@/lib/useCtaTracker";

export { Header, Footer };

export const Page = ({ children }) => {
  useCtaTracker();
  return (
    <div className="App min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">{children}</main>
      <PromiseStrip />
      <Footer />
    </div>
  );
};
